module.exports = __webpack_public_path__ + "static/media/stem-cell.5ee361ab.png";